import UnsupportedFailed from './unsupported-failed';

export default UnsupportedFailed;
